export default __webpack_public_path__ + "static/media/website.952a77c4.svg";